if (!customElements.get("td-heatmap-consent")) {
  class TdHeatmapConsent extends HTMLElement {
    constructor() {
      super();
      this.handleVisitorConsentCollected = this.handleVisitorConsentCollected.bind(this);
      this.handlePrivacyApiReady = this.handlePrivacyApiReady.bind(this);
      this.isConsentListenerBound = false;
    }

    connectedCallback() {
      this.heatmapSid = this.dataset.heatmapSid;
      this.heatmapBaseUrl = this.dataset.heatmapBaseUrl;
      this.heatmapTrackerPath = this.dataset.heatmapTrackerPath;

      this.initConsentGate();
    }

    disconnectedCallback() {
      if (this.isConsentListenerBound) {
        document.removeEventListener("visitorConsentCollected", this.handleVisitorConsentCollected);
        this.isConsentListenerBound = false;
      }
    }

    initConsentGate() {
      if (!this.heatmapSid || !this.heatmapBaseUrl || !this.heatmapTrackerPath) return;
      if (!window.Shopify || !window.Shopify.loadFeatures) return;

      window.Shopify.loadFeatures(
        [{ name: "consent-tracking-api", version: "0.1" }],
        this.handlePrivacyApiReady
      );
    }

    handlePrivacyApiReady(error) {
      if (error || !window.Shopify || !window.Shopify.customerPrivacy) return;

      if (window.Shopify.customerPrivacy.analyticsProcessingAllowed()) {
        this.loadHeatmap();
        return;
      }

      if (!this.isConsentListenerBound) {
        document.addEventListener("visitorConsentCollected", this.handleVisitorConsentCollected);
        this.isConsentListenerBound = true;
      }
    }

    handleVisitorConsentCollected(event) {
      if (event.detail && event.detail.analyticsAllowed) {
        this.loadHeatmap();
      }
    }

    loadHeatmap() {
      if (window.__tdHeatmapLoaded) return;

      window.__tdHeatmapLoaded = true;

      if (this.isConsentListenerBound) {
        document.removeEventListener("visitorConsentCollected", this.handleVisitorConsentCollected);
        this.isConsentListenerBound = false;
      }

      (function (h, e, a, t, m, ap) {
        (h._heatmap_paq = []).push(["setTrackerUrl", (h.heatUrl = e) + a]);
        h.hErrorLogs = h.hErrorLogs || [];
        ap = t.createElement("script");
        ap.src = h.heatUrl + "preprocessor.min.js?sid=" + m;
        ap.defer = true;
        t.head.appendChild(ap);

        ["error", "unhandledrejection"].forEach(function (ty) {
          h.addEventListener(ty, function (et) {
            h.hErrorLogs.push({ type: ty, event: et });
          });
        });
      })(window, this.heatmapBaseUrl, this.heatmapTrackerPath, document, this.heatmapSid);
    }
  }

  customElements.define("td-heatmap-consent", TdHeatmapConsent);
}
